import React, { useState } from "react";
import "./ComputingCapabilty.css";
import img1 from "../computingassets/img1.png";
import img2 from "../computingassets/img2.png";
import img3 from "../computingassets/img3.png";
import img4 from "../computingassets/img4.png";
import img5 from "../computingassets/img5.png";
import img6 from "../computingassets/img6.png";

const cards = [
  {
    img: img1,
    title: "Cloud Migrations",
    desc: "Migrate confidently with AWS-certified experts who design cloud roadmaps that minimize downtime, optimize resources, and accelerate ROI through a proven, secure consulting approach.",
  },
  {
    img: img2,
    title: "Hybrid and Multi-Cloud",
    desc: "Unlock flexibility with hybrid and multi-cloud strategies. We orchestrate workloads across AWS, Azure, and GCP to enhance performance, scalability, resilience, and operational efficiency.",
  },
  {
    img: img3,
    title: "Backup & Disaster Recovery",
    desc: "Protect your business from disruptions with cloud-native backup and disaster recovery solutions that ensure data integrity, compliance, and continuous operations.",
  },
  {
    img: img4,
    title: "Kubernetes Adoption",
    desc: "Adopt Kubernetes the right way. From cluster design to workload optimization, we help enterprises achieve scalable, secure, production-grade deployments.",
  },
  {
    img: img5,
    title: "Containers & Microservices",
    desc: "Break the monolith with microservices architectures that accelerate releases, improve scalability, and future-proof applications through modern cloud-native solutions.",
  },
  {
    img: img6,
    title: "CI/CD Consulting",
    desc: "Deliver faster with confidence. Our CI/CD frameworks streamline pipelines, reduce release risk, and boost developer productivity within a secure cloud ecosystem.",
  }
];

export default function ComputingCapability() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % cards.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + cards.length) % cards.length);
  };

const slidesCount = Math.ceil(cards.length / 2);

  return (
    <section id="computing-capability" className="cloudmainclass">
      <div className="cloud-header">
        <h2 className="heading">
          Cloud-Powered Innovation for High-Performing Enterprises
        </h2>   
        <p className="subheading">
          Unlock measurable impact with expert cloud consulting—streamlining
          data, reducing costs, and enabling scalable, cloud-native
          architectures for agile, future-ready enterprises.
        </p>
      </div>

      <div className="cloud-cards cloud-cards-desktop">
        {cards.map((card, index) => (
          <div className="cloud-card" key={index}>
            <div className="card-image">
              <img src={card.img} alt={card.title} />
            </div>
            <div className="card-content">
              <h3>{card.title}</h3>
              <p>{card.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="cloud-carousel-mobile">
        <button onClick={prevSlide} className="carousel-button carousel-prev">
          &#8249;
        </button>

        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {cards.map((card, index) => (
              <div className="carousel-slide" key={index}>
                <div className="cloud-card">
                  <div className="card-image">
                    <img src={card.img} alt={card.title} />
                  </div>
                  <div className="card-content">
                    <h3>{card.title}</h3>
                    <p>{card.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <button onClick={nextSlide} className="carousel-button carousel-next">
          &#8250;
        </button>
      </div>

 <div className="carousel-dots">
  {Array.from({ length: slidesCount }).map((_, index) => (
    <button
      key={index}
      onClick={() => setCurrentSlide(index)}
      className={`carousel-dot ${currentSlide === index ? "active" : ""}`}
    />
  ))}
</div>


    </section>
  );
}
